/**
 * CardStackToggle.js
 */

import $ from 'jquery';

export default class CardStackToggle {

    constructor(element) {
        
        this.wrapper = element;
        this.cardStackLinks = $('.card-stack-link', this.wrapper);
        this.cardStacks = $('.card-stack', this.wrapper);
        this.cardStackLinks.on('click', this.activateStack.bind(this));

    }

    activateStack(evt) {
        var target = $(evt.target);
        var activeItem = this.cardStacks.get(target.data('stack-item'));

        target.addClass('text-charcoal');
        this.cardStackLinks.not(target).removeClass('text-charcoal');

        $(this.cardStacks).each(function(index, element) {
            if (element === activeItem) {
                element.classList.add('active-stack')
            } else {
                element.classList.remove('active-stack')
            }
        })
    }

}

